import { Component, OnInit, AfterViewInit, Input } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NbAuthService, NbAuthResult } from '@nebular/auth'
import { takeUntil } from 'rxjs/operators'
import { Subject } from 'rxjs'
import { RouterPath } from '../../../config/global-const'
import { SharedService } from '../../../@core/services/shared.service'
import { AuthService } from '../../../@core/services/auth.service'
import { format } from 'date-fns'

@Component({
    selector: 'oauth-callback',
    templateUrl: './oauth-callback.component.html',
    styleUrls: ['./oauth-callback.component.css'],
})
export class OauthCallbackComponent implements OnInit {
    @Input()
    protected socialType: string = 'undefined'
    protected codeFieldName: string = 'code'
    private destroy$ = new Subject<void>()
    authError: boolean = false
    showRegistration: boolean = false
    code: string
    idToken: string
    saintsName: string
    firstName: string
    lastName: string
    dateOfBirth: Date
    verifyPhoneNumberRequired: boolean = true
    phoneNumber: string = ''
    verifyCode: string
    gender: string = '1'
    step = 1
    errorMessage: string

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private sharedService: SharedService,
        private nbAuthService: NbAuthService,
        private authService: AuthService
    ) {}

    ngOnInit() {
        const params: any = this.route['snapshot']['queryParams']
        this.code = params[this.codeFieldName]
        this.nbAuthService
            .authenticate('oauth', { socialType: this.socialType, code: this.code })
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (authResult: NbAuthResult) => {
                    if (authResult.isSuccess()) {
                        return void this.router.navigate([RouterPath.WORKING.FULL_PATH])
                    }
                    if (authResult.getResponse().status === 467) {
                        const { validateResult } = authResult.getResponse()?.error?.data
                        this.idToken = validateResult?.token
                        this.firstName = validateResult?.firstName
                        this.lastName = validateResult?.lastName
                        this.verifyPhoneNumberRequired = validateResult?.verifyPhoneNumberRequired
                        this.showRegistration = true
                        return
                    }
                    this.authError = true
                    setTimeout(() => {
                        return void this.router.navigate([RouterPath.AUTH.LOGIN.FULL_PATH])
                    }, 5000)
                },
                (err) => {
                    console.error(err)
                }
            )
    }

    async onButtonNextClick() {
        this.errorMessage = null
        switch (this.step) {
            case 1: {
                if (!(await this.validateStep1())) {
                    return
                }
                if (this.verifyPhoneNumberRequired) {
                    this.step = 2
                } else {
                    this.step = 3
                }
                break
            }
            case 2: {
                if (!(await this.validateStep2())) {
                    return
                }
                this.step = 3
                break
            }
            case 3: {
                if (!(await this.validateStep3())) {
                    return
                }
                //
                this.register()
            }
        }
    }

    async onButtonPrevClick() {
        this.errorMessage = ''
        switch (this.step) {
            case 1: {
                break
            }
            case 2: {
                this.step = 1
                break
            }
            case 3: {
                if (this.verifyPhoneNumberRequired) {
                    this.step = 2
                } else {
                    this.step = 1
                }
                break
            }
        }
    }

    async validateStep1() {
        if (!this.phoneNumber) {
            this.errorMessage = 'Xin nhập số điện thoại của bạn'
            return false
        }
        this.phoneNumber = this.phoneNumber.trim()
        if (!this.phoneNumber.match(/^0?\d{9}$/)) {
            this.errorMessage = 'Số điện thoại không đúng định dạng'
            return false
        }
        // call api
        const res = await this.authService.checkPhoneNumber(this.phoneNumber, true).toPromise()
        if (!res) {
            return false
        }
        let error = res.errorMessage || res?.data?.errorMessage
        if (error) {
            this.errorMessage = error
            return false
        }
        return true
    }
    async validateStep2() {
        if (!this.verifyCode) {
            this.errorMessage = 'Xin nhập mã xác thực'
            return false
        }
        this.verifyCode = this.verifyCode.trim()
        if (!this.verifyCode.match(/^\d{4,6}$/)) {
            this.errorMessage = 'Mã xác thực không đúng định dạng'
            return false
        }
        // call api
        let errRes
        await this.authService.verifyPhoneNumber(this.phoneNumber, this.verifyCode).toPromise((err) => {
            errRes = err
        })
        if (errRes) {
            if (errRes?.error?.errorMessage) {
                this.errorMessage = errRes.error.errorMessage
            } else {
                this.errorMessage = 'Không thể xác thực, vui lòng thử lại sau'
            }
            return false
        }
        return true
    }
    async validateStep3() {
        if (!this.saintsName || !this.saintsName.trim()) {
            this.errorMessage = 'Xin nhập tên Thánh của bạn'
            return false
        }
        if (!this.lastName || !this.lastName.trim()) {
            this.errorMessage = 'Xin nhập họ của bạn'
            return false
        }
        if (!this.firstName || !this.firstName.trim()) {
            this.errorMessage = 'Xin nhập tên của bạn'
            return false
        }
        if (!this.dateOfBirth) {
            this.errorMessage = 'Xin nhập ngày sinh của bạn'
            return false
        }
        return true
    }

    register() {
        this.errorMessage = ''
        const data = {
            forceRegister: true,
            socialType: this.socialType,
            token: this.idToken,
            phoneNumber: this.phoneNumber,
            verifyCode: this.verifyCode,
            saintsName: this.saintsName,
            firstName: this.firstName,
            lastName: this.lastName,
            dateOfBirth: format(this.dateOfBirth, 'yyyy-MM-dd'),
            gender: this.gender,
        }
        this.nbAuthService
            .authenticate('oauth', data)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (authResult: NbAuthResult) => {
                    if (authResult.isSuccess()) {
                        return void this.router.navigate([RouterPath.WORKING.FULL_PATH])
                    }
                    const errors = authResult.getErrors()
                    if (errors.length) {
                        this.errorMessage = errors[0]
                        setTimeout(() => {
                            return void this.router.navigate([RouterPath.AUTH.LOGIN.FULL_PATH])
                        }, 3000)
                    }
                },
                (err) => {
                    console.error(err)
                }
            )
    }
}
